<template>
  <div class="container_img">
    <div class="circle">
      <img v-if="isHsk" class="circle_icon" src="@/assets/images/hsk/title.png" alt="" />
      <img v-else class="circle_icon_yct" src="@/assets/images/hsk/yct.png" alt="" />
    </div>
    <div :class="['circle2', !isHsk ? 'circle_orange' : '']">
      <div class="circle2_level">level</div>
      <div class="circle2_num" :class="[smlFont ? 'circle2_smlNum' : '']">
        {{ levelIndex }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    levelType: {
      default: '',
      type: String,
    },
    levelNum: {
      type: Number,
    },
  },
  data() {
    return {
      levelIndex: '',
      isHsk: false,
      smlFont: '',
    }
  },
  mounted() {
    this.isHsk = this.levelType.toUpperCase().includes('HSK')
    this.levelIndex = this.isHsk && this.levelNum == 7 ? '7-9' : this.levelNum
    this.smlFont = this.isHsk && this.levelIndex == '7-9'
  },
}
</script>
<style scoped lang="scss">
.container_img {
  display: flex;
  .circle {
    border-radius: 50%;
    width: 28px;
    height: 28px;
    margin-right: -6px;
    // box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.07);
    z-index: 5;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    &_icon {
      width: 23px;
      height: 13px;
    }
    &_icon_yct {
      width: 28px;
      height: 28px;
    }
  }
  .circle2 {
    border-radius: 50%;
    width: 28px;
    height: 28px;
    border: 1px solid white;
    // box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.07);
    background: #4e8545;
    opacity: 1;
    margin-right: -20px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &_level {
      width: 30px;
      color: #fff;
      text-align: center;
      font-size: 5px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      transform: scale(0.5);
      margin-bottom: 2px;
    }
    &_num {
      color: #fff;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: -5px;
    }
    &_smlNum {
      font-size: 12px;
      transform: scale(0.8);
      line-height: 13px;
      padding-left: 1px;
    }
  }
  .circle_orange {
    background: #c97026 !important;
  }
}
</style>
